import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.TrustAsHtmlFilter,
    dependencies: [
        Token.$Sce
    ]
})
export class TrustAsHtmlFilter {
    constructor($sce: ng.ISCEService) {
        return (html => {
            return $sce.trustAsHtml(html);
        }) as any;
    }
}
